<template>
  <div id="purchasing">
    <headTop @logout="logoutClick"></headTop>
    <section class="container">
      <Modal
        title="提示"
        @on-ok="ok"
        @on-cancel="cancel"
        v-model="modal1"
        class-name="vertical-center-modal"
      >
        <p>是否删除此条地址?</p>
      </Modal>
      <div class="tips" v-if=" commitNumber>0 && totalReqNumber>0 ">
        <img src="../assets/icon-warn.jpg" alt />
        <p>
          <b>提示：</b>
          <span v-if="commitNumber>0">
            已提交
            <span style="color:#c41335">{{commitNumber}}</span>个消防设施&nbsp;
          </span>
          <span v-if="totalReqNumber>0">
            剩余
            <span style="color:#c41335">{{totalReqNumber}}</span>个消防设施未提交
          </span>
        </p>
      </div>
      <!--采购订单 -->
      <div class="shopping" v-if="list1.length>0">
        <div class="status">发布采购订单</div>
        <div class="orderInfor">
          <div>确认采购订单信息</div>
        </div>

        <ul>
          <li v-for="(item,index) of list1" :key="index">
            <!-- <div class="company_name">
              <div class="check" :class="{'check_active':item.checked}"></div>
              <div class="company">{{item.company_name}}</div>
              <div class="QQ"></div>
            </div>-->
            <div v-for="(list,inx) of item.goodsDetailList" :key="inx">
              <div class="goods">
                <div class="checked" :class="{'active':list.checked}" @click="select(list,item)"></div>
                <div class="goods_img">
                  <img :src="list.product_cover" alt />
                </div>
                <div class="goods_content">
                  <div class="title">{{list.product_name}}</div>
                  <div
                    class="size"
                  >{{ JSON.parse(list.spec_detail)["规格"]}};{{JSON.parse(list.spec_detail)["颜色"]}}</div>
                </div>
              </div>
              <div class="count">
                <button class="reduce" :disabled="list.number<=1" @click="reduceNumber(list)"></button>
                <div class="number">
                  <!--<input type="number" @blur="updateNumber(list,1)" @input="checkValue(list)" v-model="list.number"/>-->
                  <input
                    @blur="updateNumber(list,1)"
                    oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
                    v-model="list.number"
                  />
                </div>
                <button class="add" @click="addNumber(list)"></button>
              </div>
            </div>
          </li>
        </ul>
        <div class="order_show" v-if="orders1.length>0">
          <img src="../assets/tips.png" alt />
          此订单需实地勘察后报价后续会有供应商与您联系
        </div>
        <div class="order_submit">
          <div class="goods_count">
            共
            <span>{{orders1.length}}</span> 件产品
          </div>
          <div class="order_btn" :class="{'color':orders1.length>0}" @click="submitOrders">提交订单</div>
        </div>
      </div>
      <!-- 购买产品订单 -->
      <div class="buy_goods" v-if="list2.length>0">
        <div class="status">购买产品订单</div>
        <div class="orderInfor">
          <div class="title">确认收货地址</div>
        </div>
        <div class="adress">
          <div
            class="adress_box"
            v-if="addressList.length>0"
            :style="{'width':200 * addressList.length +'px'}"
          >
            <div
              class="list"
              v-for="(item,index) of addressList"
              :key="index"
              :class="{'border':index==table}"
              @click="tabChange(index)"
            >
              <div class="deful" v-if="item.is_default==1">默认地址</div>
              <div class="name">{{item.name}}</div>
              <div class="phone">{{item.phone}}</div>
              <div class="city">{{item.province}} {{item.city}} {{item.area}}</div>
              <div class="detial">{{item.address}}</div>
              <div class="modify">
                <span @click="delete_Adress(item.id)">删除</span> |
                <span @click="modify_Adress(item)">修改</span> |
                <span @click="setDefaul_Adress(item.id)">设为默认地址</span>
              </div>
              <div v-if="index==table" class="default"></div>
            </div>
          </div>
        </div>

        <div class="add_box">
          <div class="addAdress" @click="addAdress">+ 新增收货地址</div>
        </div>
        <div class="orderInfor">
          <div class="title">确认订单信息</div>
        </div>
        <ul>
          <li v-for="(item,index) of list2" :key="index">
            <div class="company_name">
              <div class="check" :class="{'check_active':item.checked}" @click="selectAll(item)"></div>
              <div class="company">{{item.company_name}}</div>
              <!-- <div class="QQ"></div> -->
            </div>
            <div v-for="(list,inx) of item.goodsDetailList" :key="inx">
              <div class="goods">
                <div class="checked" :class="{'active':list.checked}" @click="select(list,item)"></div>
                <div class="goods_img">
                  <img :src="list.product_cover" alt />
                </div>
                <div class="goods_content">
                  <div class="title">{{list.product_name}}</div>
                  <div
                    class="size"
                  >{{JSON.parse(list.spec_detail)["规格"]}};{{JSON.parse(list.spec_detail)["颜色"]}}</div>
                </div>
              </div>
              <div class="count">
                <span>￥{{list.unit_price/100}}</span>
                <button class="reduce" :disabled="list.number<=1" @click="orderReduce(list)"></button>
                <div class="number">
                  <input
                    @blur="updateNumber(list,0)"
                    oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
                    v-model="list.number"
                  />
                </div>
                <button class="add" @click="orderAdd(list)"></button>
              </div>
            </div>
            <div class="transform">
              <div class="transform_type">
                <label>运送方式</label> 普通配送（免运费）
              </div>
              <div class="message">
                <label>给供应商留言</label>
                <div>
                  <!-- <input type="text" placeholder="选填，200字内" /> -->
                  <textarea name id placeholder="选填，200字内" v-model="item.message" maxlength="200"></textarea>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div class="order_submit">
          <div class="goods_count">
            共
            <span>{{orders2.count}}</span> 件产品&nbsp;&nbsp;&nbsp;&nbsp; 实付款
            <span>￥{{orders2.total?orders2.total:0}}</span>
          </div>
          <div class="order_btn" :class="{'color':orders2.count>0}" @click="confirmOrder">提交订单</div>
        </div>
      </div>
    </section>
    <Pay
      type="4"
      :show="showpay"
      :buy="orders2.total"
      :buyid="buyid"
      :order="order"
      @payValue="payValue"
    ></Pay>
    <Success :show="success" type="2" @successViewClick="closeSuccess"></Success>
    <AlertView
      :show="alertShow"
      subTitle="您有未支付的订单，请到订单中心支付!"
      @alertViewClick="viewClick"
      title
      cancelTitle="取消"
      sureTitle="查看订单"
    ></AlertView>
  </div>
</template>
<script>
import headTop from './header'
import Pay from '../components/buy'
import Success from '../components/success-view'
import AlertView from '../components/alert-view'
import { _throttle } from '../utils/public'
// import QS from 'qs'

// import footBottom from './footer'
export default {
  name: 'purchasing',
  components: { headTop, Pay, Success, AlertView },
  data () {
    return {
      single: true,
      params: '', // 获取数据的参数
      count: 1,
      list1: [],
      list2: [],
      addressList: [], // 地址列表
      modal1: false,
      id: '', // 删除地址的id
      showpay: false,
      order: '', // 生成订单的参数
      resultId: '',
      commitNumber: 0,
      totalReqNumber: 0,
      buyid: '', // 购买产品的ID
      success: false,
      table: 0,
      oldList: [],
      alertShow: false,
      onceOrder: false
    }
  },
  created () {
    this.getAdress()
  },
  mounted () {
    let onceOrder = localStorage.getItem('onceOrder') || '0' // 0 第一次进入 1再次进入
    if (onceOrder === '0') {
      this.onceOrder = false
    } else if (onceOrder === '1') {
      this.onceOrder = true
    }

    let shop = localStorage.getItem('shop')
    this.params = JSON.parse(shop)
    this.getData(this.params)

    let id = localStorage.getItem('resultId') // 获取resultId
    this.resultId = id
    if (this.resultId || this.resultId !== '') {
      this.goodsNumber()
    }
  },
  computed: {
    show () {
      if (this.onceOrder) {
        if (this.commitNumber > 0 || this.totalReqNumber > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    orders1 () {
      let arr = []
      for (let item of this.list1) {
        if (item.goodsDetailList || item.goodsDetailList.length > 0) {
          for (let list of item.goodsDetailList) {
            if (list.checked) {
              arr.push(list)
            }
          }
        }
      }
      return arr
    },
    orders2 () {
      let arr = []
      var total = ''

      for (let item of this.list2) {
        if (item.goodsDetailList || item.goodsDetailList.length > 0) {
          for (let list of item.goodsDetailList) {
            if (list.checked) {
              let price = Number(list.unit_price) / 100
              let number = list.number
              total = Number(total)
              total += price * number

              arr.push(list)
            }
          }
        }
      }

      return {
        count: arr.length,
        total: String(total)
      }
    }

  },
  methods: {
    getData (params) {
      if (params.length > 0) {
        var arr1 = []
        var arr2 = []
        for (let item of params) { // 购买产品订单
          if (item.type === 0) {
            arr1.push(item)
          }
          if (item.type === 1) { // 确认采购订单
            arr2.push(item)
          }
        }
      }

      let params1 = new Promise((resolve, reject) => {
        this.utils.POSTQS(this.companyUrl + '/zxOrder/settlementData', false, arr1, resp => {
          resolve(resp)
        })
      })

      let params2 = new Promise((resolve, reject) => {
        this.utils.POSTQS(this.companyUrl + '/zxOrder/settlementData', false, arr2, resp => {
          resolve(resp)
        })
      })

      Promise.all([params1, params2]).then(res => {
        let list1 = res[1].data || [] // 确认采购订单
        let list2 = res[0].data || []// 购买产品订单

        // 记录原始数据 id 和数量
        let datalist = []
        let datalist1 = []
        for (let item of list1) {
          for (let list of item.goodsDetailList) {
            let obj = {
              'id': list.id,
              'number': list.number
            }
            datalist.push(obj)
          }
        }
        for (let item of list2) {
          for (let list of item.goodsDetailList) {
            let obj = {
              'id': list.id,
              'number': list.number
            }
            datalist1.push(obj)
          }
        }

        localStorage.setItem('confirmOrder', JSON.stringify(datalist)) // 存储采购订单
        this.oldList = datalist1

        if (list1.length > 0) {
          for (let item of list1) {
            item.checked = false
            if (item.goodsDetailList || item.goodsDetailList.length > 0) {
              for (let key of item.goodsDetailList) {
                key.checked = false
              }
            }
          }
        }
        if (list2.length > 0) {
          for (let item of list2) {
            item.checked = false
            item.message = ''
            if (item.goodsDetailList || item.goodsDetailList.length > 0) {
              for (let key of item.goodsDetailList) {
                key.checked = false
              }
            }
          }
        }
        this.list1 = list1
        this.list2 = list2
      })
    },
    viewClick (i) {
      if (i === 1) {
        // window.location.href = 'http://personal.zxzx119.com/home/orderList'
        window.location.href = this.pcOrderList
      }
      if (i === 0) {
        this.alertShow = false
      }
    },
    getAdress () { // 获取地址列表
      this.utils.GET(this.accountUrl + '/site/list', res => {
        this.addressList = res.data
      })
    },
    cancelAlert (i) {
      if (i === 0) {
        this.alertShow = false
      }
    },
    goodsNumber () {
      this.utils.GET(`${this.accountUrl}/riskeval/getResultGoodsNumber?resultId=${this.resultId}`, res => {
        if (res.success) {
          this.commitNumber = res.data.totalCommitNumber || 0 // 已提交的个数
          this.totalReqNumber = res.data.totalReqNumber || 0 // 剩余的个数
        }
        console.log(res)
      })
    },
    modify_Adress (e) { // 修改地址
      this.$router.push({
        path: '/adress',
        query: {
          adress: JSON.stringify(e),
          type: 0
        }
      })
    },
    delete_Adress (id) { // 删除地址
      this.id = id
      this.modal1 = true
    },
    setDefaul_Adress (id) { // 设置默认地址
      this.utils.POSTQS(this.accountUrl + `/site/default/set?id=${id}`, false, null, resp => {
        if (resp.success) {
          this.table = 0
          this.$Message.success(`${resp.message}`)
          this.getAdress()
        }
      })
    },
    ok () { // 确定删除地址
      this.utils.POSTQS(this.accountUrl + `/site/delete?id=${this.id}`, false, null, resp => {
        if (resp.success) {
          this.$Message.success(`${resp.message}`)
          this.id = ''
          this.getAdress()
        }
      })
    },
    cancel () {
      this.id = ''
    },
    reduceNumber (list) { // 采购订单
      if (list.number <= 1) {
        list.number = 1
      } else {
        list.number--
      }
      let params = list
      params.type = 1
      params.count = Number(list.number) * Number(list.unit_price)
      params.color = JSON.parse(params.spec_detail)['颜色']
      params.spec = JSON.parse(params.spec_detail)['规格']
      this.utils.POSTHeader(this.companyUrl + '/shoppingCart/update', {
        'Content-Type': 'application/json',
        'Cache-control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 0,
        'zxzxkey': ''
      }, params, (res) => {
        console.log(res)
      })
    },
    addNumber (list) { // 采购订单
      let params = list
      params.number++
      params.type = 1
      params.count = Number(list.number) * Number(list.unit_price)
      params.color = JSON.parse(params.spec_detail)['颜色']
      params.spec = JSON.parse(params.spec_detail)['规格']
      this.utils.POSTHeader(this.companyUrl + '/shoppingCart/update', {
        'Content-Type': 'application/json',
        'Cache-control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 0,
        'zxzxkey': ''
      }, params, (res) => {

      })
    },

    orderAdd (list) {
      let params = list
      params.number++
      params.type = 0
      params.count = Number(list.number) * Number(list.unit_price)
      params.color = JSON.parse(params.spec_detail)['颜色']
      params.spec = JSON.parse(params.spec_detail)['规格']
      this.utils.POSTHeader(this.companyUrl + '/shoppingCart/update', {
        'Content-Type': 'application/json',
        'Cache-control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 0,
        'zxzxkey': ''
      }, params, (res) => {

      })
    },
    orderReduce (list) {
      if (list.number <= 1) {
        list.number = 0
      } else {
        list.number--
      }
      let params = list
      params.type = 0
      params.count = Number(list.number) * Number(list.unit_price)
      params.color = JSON.parse(params.spec_detail)['颜色']
      params.spec = JSON.parse(params.spec_detail)['规格']
      this.utils.POSTHeader(this.companyUrl + '/shoppingCart/update', {
        'Content-Type': 'application/json',
        'Cache-control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 0,
        'zxzxkey': ''
      }, params, (res) => {
        console.log(res)
      })
    },
    //  checkValue (item) {
    //    if (item.number) {
    //      let number = item.number.toString()
    //      item.number = Number(number.slice(0, 5))
    //    }
    //  },
    select (item, list) {
      item.checked = !item.checked
      let bool = list.goodsDetailList.every(function (k, i) {
        return k.checked === true
      })
      if (bool) {
        list.checked = true
      } else {
        list.checked = false
      }
    },
    selectAll (item) { // 全选功能
      item.checked = !item.checked
      if (item.checked) {
        if (item.goodsDetailList || item.goodsDetailList.length > 0) {
          for (let list of item.goodsDetailList) {
            list.checked = true
          }
        }
      } else {
        if (item.goodsDetailList || item.goodsDetailList.length > 0) {
          for (let list of item.goodsDetailList) {
            list.checked = false
          }
        }
      }
    },
    submitOrders () { // 提交采购订单
      if (this.orders1.length > 0) {
        var id = ''
        let pushList = []
        for (let item of this.orders1) {
          id += item.tails.cartId + ','
        }
        id = id.slice(0, -1)
        this.$router.push(
          {
            path: '/modify-information',
            query: {
              ids: id,
              pushList: JSON.stringify(pushList) // 提交的商品和数量
            }
          })
      }
    },
    confirmOrder: _throttle(function () {
      if (this.orders2.count > 0) {
        if (sessionStorage.getItem('orderid')) {
          this.alertShow = true
          // this.$Message.success('您有未支付的订单，请到订单中心支付!')
          return
        }

        let id = ''
        if (this.addressList.length === 0) {
          this.$Message.success('请添加收货地址')
          return
        }
        var checkList = []

        let goodsDetailList = []
        let levemessage = []
        let cartIds = ''
        this.list2.forEach((item, index) => {
          levemessage.push({
            'supplier_id': item.supplier_id,
            'leave_word': item.message
          })
          // 选择选中的订单列表
          item.goodsDetailList.forEach((ite, inde) => {
            if (ite.checked) {
              checkList.push(ite)
            }
          })
        })

        for (let list of checkList) {
          let obj = {}
          id += list.id + ','
          cartIds += list.tails.cartId + ','
          obj.id = list.id
          obj.goods_id = list.goods_id
          obj.product_name = list.product_name
          obj.product_cover = list.product_cover
          obj.number = list.number
          obj.unit_price = list.unit_price
          obj.count = list.number * list.unit_price
          obj.spec_detail = list.spec_detail
          obj.price_type = list.price_type
          obj.riskeval_result_id = this.resultId // result.id
          goodsDetailList.push(obj)
        }

        let adress = this.addressList[this.table] // 获取地址信息
        let tails = {
          'receiver': adress.name, // 姓名
          'freight': 0, // 0 免运费
          'province_city_area': `${adress.province}${adress.city}${adress.area}`, // 省市区
          'province': adress.province, // 省份
          'city': adress.city, // 市
          'area': adress.area, // 区
          'detail_address': adress.address // 详细地址
        }

        let formdata = {
          'user_phone': adress.phone, // 手机号
          'amount': this.orders2.total * 100, // 总金额
          'is_contains_eval': 1,
          'tails': tails, // 用户信息
          'leaveWordList': levemessage, // 留言内容
          'goodsDetailList': goodsDetailList,
          'cartIds': cartIds.slice(0, -1)

        }
        this.order = JSON.stringify(formdata)
        this.buyid = id.slice(0, -1)
        this.showpay = true
      }
    }, 3000),
    addAdress () { // 新增地址
      this.$router.push({ path: '/adress' })
    },
    payValue (e) {
      if (e === 0) { // 取消
        this.showpay = false
      }
      if (e === 1) { // 付款成功
        this.showpay = false
        this.success = true
      }
    },
    closeSuccess () { // 关闭付款成功界面跳转结果页面
      this.success = false
      this.$router.replace(
        {
          path: '/home',
          query: {
            resultId: this.resultId
          }
        })
    },
    updateNumber (item, i) {
      let params = item
      if (!params.number) {
        params.number = 1
      }
      params.type = i
      params.number = Number(params.number)
      params.count = Number(item.number) * Number(item.unit_price)
      params.color = JSON.parse(params.spec_detail)['颜色']
      params.spec = JSON.parse(params.spec_detail)['规格']
      this.utils.POSTHeader(this.companyUrl + '/shoppingCart/update', {
        'Content-Type': 'application/json',
        'Cache-control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 0,
        'zxzxkey': ''
      }, params, (res) => {

      })
    },
    tabChange (i) {
      this.table = i
    },
    logoutClick () { // 退出登录
      this.$router.replace('home')
    }

  },
  beforeRouteEnter (to, from, next) {
    document.body.style = 'background:#f4f4f4'
    next()
  },

  beforeRouteLeave (to, from, next) {
    document.body.style = 'background:#fff'
    next()
  }
}
</script>

<style scoped lang="scss">
#purchasing {
  * {
    padding: 0;
    margin: 0;
  }
  background: #f4f4f4;
  font-size: 'MicrosoftYaHei';
  .container {
    .tips {
      width: calc(100% - 31px);
      height: 33px;
      line-height: 33px;
      margin: 0 auto;
      background: #fecdcd;
      margin: 10px 15px;
      display: flex;
      display: -webkit-flex;
      font-size: 12px;
      color: #0e050a;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        b {
          font-size: 12px;
          font-weight: bold;
          color: #0e050a;
        }
      }

      img {
        width: 15px;
        height: 15px;
        margin-top: 9px;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
    .shopping {
      width: 100%;
      .status {
        width: calc(100% - 30px);
        height: 35px;
        line-height: 35px;
        color: #fff;
        margin: 15px auto 0;
        background: rgba(196, 19, 53, 1);
        border-radius: 4px 4px 0px 0px;
        font-size: 13px;
        padding-left: 15px;
      }
      .orderInfor {
        width: calc(100% - 30px);
        padding-left: 15px;
        height: 43px;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        background: #fff;
        div {
          height: 43px;
          line-height: 43px;
          border-bottom: 2px solid rgba(196, 19, 53, 1);
          color: #000;
          font-size: 14px;
          padding: 0 2px;
        }
      }
      ul {
        width: calc(100% - 30px);
        margin: 0 auto;
        background: #fff;
        border-top: 1px solid #f4f4f4;
        border-bottom: 1px solid #f4f4f4;
        li {
          list-style: none;
          padding: 0 15px;
          position: relative;
          border-bottom: 1px solid #f4f4f4;

          .company_name {
            display: flex;
            display: -webkit-flex;
            font-size: 14px;
            color: #0e050a;
            font-weight: 700;
            height: 50px;
            line-height: 50px;
            position: relative;
            .check {
              width: 20px;
              height: 20px;
              border: 1px solid #eee;
              border-radius: 50%;
              margin-top: 15px;
              margin-right: 15px;
            }
            .check_active {
              background: url('../assets/radio_s.png') no-repeat center center;
              background-size: 100%;
            }
            .company {
              width: 65%;
              height: 30px;
              line-height: 30px;
              font-weight: 700;
              color: #0e050a;
              font-size: 14px;
              margin-top: 10px;
              font-family: 'MicrosoftYaHei-Bold';
            }
            .QQ {
              height: 20px;
              width: 66px;
              line-height: 20px;
              font-size: 10px;
              color: #ae112f;
              padding: 0 5px;
              position: absolute;
              top: 15px;
              right: 0px;
              background: url('../assets/qq.png') no-repeat center center;
              background-size: 100%;
            }
          }
          .goods {
            margin-top: 10px;
            align-items: center;
            height: 90px;
            display: flex;
            display: -webkit-flex;
            .checked {
              width: 20px;
              height: 20px;
              border: 1px solid #eee;
              border-radius: 50%;
              margin-right: 15px;
            }
            .active {
              background: url('../assets/radio_s.png') no-repeat center center;
              background-size: 100%;
            }
            .goods_img {
              width: 90px;
              height: 90px;
              border: 1px solid #eee;
              margin-right: 15px;
              img {
                width: 88px;
                height: 88px;
              }
            }
            .goods_content {
              width: calc(100% - 145px);
              font-size: 13px;
              color: #0e050a;
              .title {
                font-size: 13px;
                line-height: 20px;
                max-height: 13px;
              }
              .size {
                margin-top: 10px;
                background: #eee;
                max-height: 40px;
                color: #808080;
                font-size: 12px;
                line-height: 15px;
                padding: 5px
              }
            }
          }
          .count {
            padding: 15px 6px 20px 0;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            .add {
              width: 22px;
              height: 22px;
              background: #eee url('../assets/add.png') no-repeat center center;
              background-size: 50%;
              border-radius: 2px;
              border: none;
              outline: none;
            }
            .number {
              width: 40px;
              height: 22px;
              margin: 0 10px;
              border: 1px solid #eee;
              border-radius: 2px;
              input {
                width: 100%;
                height: 22px;
                border: none;
                outline: none;
                text-align: center;
              }
            }
            .reduce {
              width: 22px;
              height: 22px;
              background: #eee;
              border-radius: 2px;
              border: none;
              outline: none;
              background: #eee url('../assets/reduce.png') no-repeat center
                center;
              background-size: 50%;
            }
          }
        }
      }
      .order_show {
        width: calc(100% - 30px);
        margin: 0 auto;
        height: 41px;
        line-height: 41px;
        background: #ffecec;
        color: #ae112f;
        display: -webkit-flex;
        display: flex;
        border: 1px solid #fecdcd;
        img {
          width: 25px;
          height: 25px;
          margin: 8px 12px 0 15px;
        }
      }
      .order_submit {
        width: calc(100% - 30px);
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        border: 1px solid #fecdcd;
        border-top: none;
        .goods_count {
          width: calc(100% - 94px);
          height: 40px;
          background: #ffecec;
          text-align: right;
          line-height: 40px;
          font-size: 13px;
          padding-right: 20px;
          span {
            color: #ae112f;
          }
        }
        .order_btn {
          width: 94px;
          height: 40px;
          color: #fff;
          background: #fecdcd;
          text-align: center;
          line-height: 40px;
          font-size: 13px;
        }
        .color {
          background: #c41335;
        }
      }
    }
    .buy_goods {
      width: 100%;
      .status {
        width: calc(100% - 30px);
        height: 35px;
        line-height: 35px;
        color: #fff;
        margin: 15px auto 0;
        background: rgba(196, 19, 53, 1);
        border-radius: 4px 4px 0px 0px;
        font-size: 13px;
        padding-left: 15px;
      }
      .orderInfor {
        width: calc(100% - 30px);
        padding-left: 15px;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        background: #fff;
        .title {
          height: 43px;
          line-height: 43px;
          border-bottom: 2px solid rgba(196, 19, 53, 1);
          color: #000;
          font-size: 14px;
          padding: 0 2px;
        }
      }
      .adress {
        width: calc(100% - 30px);
        margin: 0 auto;
        padding: 10px;
        background: #fff;
        overflow-x: auto;
        .adress_box {
          width: 1850px;
          height: 140px;
          overflow-x: auto;
          display: inline-block;
          .list {
            width: 185px;
            min-height: 140px;
            position: relative;
            background: #f4f4f4;
            border-radius: 5px;
            overflow: hidden;
            float: left;
            margin-right: 15px;
            .deful {
              position: absolute;
              top: 0;
              right: 0;
              height: 20px;
              line-height: 20px;
              padding: 0 3px;
              background: #cccccc;
              color: #fff;
              border-radius: 0 0 0 5px;
            }
            .name {
              width: 185px;
              height: 30px;
              line-height: 30px;
              padding: 0 15px;
              font-size: 12px;
              color: #000;
              font-weight: 700;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #000;
            }
            .phone {
              padding-left: 15px;
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              color: #000;
            }
            .city {
              height: 20px;
              line-height: 20px;
              padding: 0 15px;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #000;
            }
            .detial {
              line-height: 20px;
              padding: 0 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #000;
            }
            .modify {
              display: flex;
              display: -webkit-flex;
              padding-left: 15px;
              position: absolute;
              bottom: 10px;
              left: 0px;
              color: #cccccc;
              span {
                display: inline-block;
                height: 20px;
                line-height: 20px;
                padding: 0 5px;
                color: #ae112f;
              }
              span:first-child {
                padding-left: 0;
              }
            }
            .default {
              width: 15px;
              height: 15px;
              border-radius: 2px;
              background: url('../assets/checkbox.png') no-repeat center center;
              background-size: 20px;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
          .border {
            border: 1px solid #c41335;
          }
        }
      }
      .add_box {
        height: 50px;
        background: #fff;
        width: calc(100% - 30px);
        margin: 0 auto;
        overflow: hidden;
        .addAdress {
          width: 105px;
          height: 35px;
          line-height: 35px;
          color: #c41335;
          font-size: 12px;
          border: 1px solid #fecdcd;
          margin: 0 15px 15px 15px;
          text-align: center;
          border-radius: 4px;
        }
      }

      ul {
        width: calc(100% - 30px);
        margin: 0 auto;
        background: #fff;
        border-top: 1px solid #f4f4f4;
        border-bottom: 1px solid #f4f4f4;
        li {
          list-style: none;

          position: relative;
          border-bottom: 1px solid #f4f4f4;

          .company_name {
            padding: 0 15px;
            display: flex;
            display: -webkit-flex;
            font-size: 14px;
            color: #0e050a;
            font-weight: 700;
            height: 50px;
            line-height: 50px;
            position: relative;
            .check {
              width: 20px;
              height: 20px;
              border: 1px solid #eee;
              border-radius: 50%;
              margin-top: 15px;
              margin-right: 15px;
            }
            .check_active {
              background: url('../assets/radio_s.png') no-repeat center center;
              background-size: 100%;
            }
            .company {
              width: 65%;
              height: 30px;
              line-height: 30px;
              font-weight: 700;
              color: #0e050a;
              font-size: 14px;
              margin-top: 10px;
              font-family: 'MicrosoftYaHei-Bold';
            }
            .QQ {
              height: 20px;
              width: 66px;
              line-height: 20px;
              font-size: 10px;
              color: #ae112f;
              position: absolute;
              top: 15px;
              right: 15px;
              background: url('../assets/qq.png') no-repeat center center;
              background-size: 100%;
            }
          }
          .transform {
            border: 1px solid #f4f4f4;
            margin: 0 auto;
            padding: 0 15px;
            background: #fff;
            .transform_type {
              font-size: 12px;
              color: #000;
              height: 30px;
              line-height: 30px;
              label {
                display: inline-block;
                width: 80px;
              }
            }
            .message {
              font-size: 12px;
              color: #000;
              height: 30px;
              line-height: 30px;
              display: flex;
              label {
                display: inline-block;
                width: 80px;
              }
              div {
                width: calc(100% - 80px);
                textarea {
                  width: 100%;
                  height: 100%;
                  border: none;
                  outline: none;
                  font-size: 13px;
                }
                textarea::placeholder {
                  font-size: 12px;
                  color: #bebebe;
                  padding-left: 4px;
                }
              }
            }
          }
          .goods {
            padding: 0 15px;
            align-items: center;
            height: 90px;
            display: flex;
            display: -webkit-flex;
            margin-top: 10px;
            .checked {
              width: 20px;
              height: 20px;
              border: 1px solid #eee;
              border-radius: 50%;
              margin-right: 15px;
            }
            .active {
              background: url('../assets/radio_s.png') no-repeat center center;
              background-size: 100%;
            }
            .goods_img {
              width: 90px;
              height: 90px;
              border: 1px solid #eee;
              margin-right: 15px;
              img {
                width: 88px;
                height: 88px;
              }
            }
            .goods_content {
              width: calc(100% - 145px);
              font-size: 13px;
              color: #0e050a;
              .title {
                font-size: 13px;
                line-height: 13px;
                max-height: 30px;
              }
              .size {
                margin-top: 10px;
                background: #eee;
                max-height: 40px;
                color: #808080;
                font-size: 12px;
                line-height: 15px;
                padding: 5px
              }
            }
          }
          .count {
            padding: 15px 20px 20px 0;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            width: calc(100% - 145px);
            margin-left: 145px;
            position: relative;
            span {
              color: #c41335;
              display: inline-block;
              height: 22px;
              line-height: 22px;
              position: absolute;
              top: 15px;
              left: 0;
              font-size: 12px;
            }

            .add {
              width: 22px;
              height: 22px;
              background: #eee url('../assets/add.png') no-repeat center center;
              background-size: 50%;
              border-radius: 2px;
              border: none;
              outline: none;
            }
            .number {
              width: 40px;
              height: 22px;
              margin: 0 10px;
              border: 1px solid #eee;
              border-radius: 2px;
              input {
                width: 100%;
                height: 22px;
                border: none;
                outline: none;
                text-align: center;
              }
            }
            .reduce {
              width: 22px;
              height: 22px;
              background: #eee;
              border-radius: 2px;
              background: #eee url('../assets/reduce.png') no-repeat center
                center;
              background-size: 50%;
              border: none;
              outline: none;
            }
          }
        }
      }

      .order_submit {
        width: calc(100% - 30px);
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        border: 1px solid #fecdcd;
        .goods_count {
          width: calc(100% - 94px);
          height: 40px;
          background: #ffecec;
          text-align: right;
          line-height: 40px;
          font-size: 13px;
          padding-right: 20px;
          span {
            color: #ae112f;
          }
        }
        .order_btn {
          width: 94px;
          height: 40px;
          color: #fff;
          background: #fecdcd;
          text-align: center;
          line-height: 40px;
          font-size: 13px;
        }
        .color {
          background: #c41335;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/purchasing.vue